import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'
import { InstitutionUserPerfis } from 'models'
import { InputFormUserKeys } from './types'

interface Schema {
    id: InputFormUserKeys
}

interface InputFormUserReturn {
    layout: LayoutProps
    input?: InputBuildProps & Schema
    select?: SelectBuildProps & Schema
}

export const InputFormUser = (
    idUser: string,
    perfisOptions: InstitutionUserPerfis[],
    isBackoffice: boolean
): InputFormUserReturn[] => {
    return [
        {
            input: {
                id: 'cpf',
                label: 'CPF',
                required: true,
                maskReplace: 'cpf',
                inputMode: 'numeric',
                disabled: !!idUser
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 6 }
            }
        },
        {
            input: {
                id: 'contato',
                label: 'Telefone',
                required: true,
                inputMode: 'tel',
                maskReplace: 'contato'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 6 }
            }
        },
        {
            input: {
                id: 'nome',
                label: 'Nome completo',
                maxLength: 128,
                required: true
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: !idUser ? 6 : 12 }
            }
        },
        {
            select: {
                id: 'grupo',
                label: 'Grupo',
                options: [{ text: 'Administrativo', value: '1' }]
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 6 }
            }
        },
        {
            select: {
                id: 'utilizaMfa',
                required: true,
                label: 'Utiliza MFA',
                options: [
                    { text: 'Sim', value: true },
                    { text: 'Não', value: false }
                ]
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 6 }
            }
        },
        {
            input: {
                id: 'nomeUsuario',
                label: 'Nome de usuário',
                required: true
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 6 }
            }
        },
        {
            select: {
                id: 'tipoUsuarioPerfil',
                label: 'Acesso',
                required: true,
                options: perfisOptions
                    .filter(item => {
                        if (!isBackoffice) {
                            const removeItems = ['detran', 'backoffice']
                            return !removeItems.includes(item.perfil)
                        }
                        return true
                    })
                    .map(({ id, perfil }) => ({
                        text: perfil,
                        value: id
                    }))
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 6 }
            }
        },
        {
            input: {
                id: 'email',
                label: 'E-mail',
                maxLength: 128,
                required: true,
                inputMode: 'email',
                type: 'email'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 6 }
            }
        },
        {
            input: {
                id: 'matricula',
                label: 'Matricula',
                maxLength: 20,
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 6 }
            }
        },
        {
            input: {
                id: 'alocacao',
                label: 'Unidade de Alocação',
                maxLength: 20
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 6 }
            }
        }
    ]
}
